import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var NotFoundComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NotFoundComponent, _super);
    function NotFoundComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = "Not found";
        return _this;
    }
    return NotFoundComponent;
}(AbstractPageComponent));
export { NotFoundComponent };
